import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsFormReceivedSvg = lazy(() => import('./svg-components/digital-forms-form-received-svg'));

const DigitalFormsFormReceivedSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsFormReceivedSvg {...rest} />
  </Suspense>
);

export default DigitalFormsFormReceivedSvg;
